import React, { lazy, Suspense } from 'react';

import type { IconExplorerProps } from './components/icon-explorer';

const LazyIconExplorer = lazy(() =>
	import(
		/* webpackChunkName: "@atlaskit-internal_design-system-docs-icon-explorer" */ './components/icon-explorer'
	).then(({ IconExplorer }) => ({ default: IconExplorer })),
);

export function IconExplorer({ testId }: IconExplorerProps): React.JSX.Element {
	return (
		<Suspense fallback={null}>
			<LazyIconExplorer testId={testId} />
		</Suspense>
	);
}
